import { render, staticRenderFns } from "./RecruitmentRequestForm.vue?vue&type=template&id=6bfc9d1c&"
import script from "./RecruitmentRequestForm.vue?vue&type=script&lang=js&"
export * from "./RecruitmentRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports